import React from 'react';

import QueryString from 'query-string';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';

import PropTypes from 'prop-types';

export default class CloudPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false
        };
    }

    static contextTypes = {
        router: PropTypes.object
    };


    async componentDidMount() {
        const params = QueryString.parse(this.context.router.route.location.search);
        if (params.code) {
            await this.props.authorize(params.code);
            if (!this.props.success) {
                this.setState({ error: true });
            }
            this.context.router.history.replace('/settings/system');
        }

    }

    authorizeCloudPrint() {
        this.setState({ error: false });
        window.location = `https://accounts.google.com/o/oauth2/v2/auth?scope=openid profile email https://www.googleapis.com/auth/cloudprint&access_type=offline&include_granted_scopes=true&state=state_parameter_passthrough_value&redirect_uri=${process.env.REACT_APP_GOOGLE_REDIRECT_URI}&response_type=code&client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}`;
    }

    render() {
        const { cloudPrintIsAuthorized, cloudPrintUserName } = this.props;
        return (
            <div className="column-half column-half-left cloud-print">
                {cloudPrintIsAuthorized && cloudPrintUserName && <label className="authorization"><i className="material-icons">check_circle</i>Cloud Print is authorized with user <span className="bold-text">{cloudPrintUserName}</span></label>}
                {this.props.loading ?
                    <LoadingSpinner height={20} loading={this.props.loading} />
                    : <button className="btn btn-large btn-primary icon-left" onClick={this.authorizeCloudPrint.bind(this)}>{cloudPrintIsAuthorized && cloudPrintUserName ? 'Authorize with a Different Account' : 'Authorize Cloud Print'} </button>}
                    <FadeOutErrorMessage show={this.state.error} message='Something went wrong and the account could not be authorized. Please try again.'/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/CloudPrint.jsx